export const Actions = {
  LOGIN_USER: "LOGIN_USER",
  LOGOUT_USER: "LOGOUT_USER",
  API_ALL_PLANS: "API_ALL_PLANS",
  SET_ALL_PLANS: "SET_ALL_PLANS",
  CREATE_ORG: "CREATE_ORG",
  API_ORG_DASHBOARD: "API_ORG_DASHBOARD",
  SET_ORG_DASHBOARD: "SET_ORG_DASHBOARD",
  API_USER_ORGS: "API_USER_ORGS",
  SET_USER_ORGS: "SET_USER_ORGS",
  SET_ALL_ORGS: "SET_ALL_ORGS",
  API_ALL_USERS: "API_ALL_USERS",
  SET_ALL_USERS: "SET_ALL_USERS",
  API_USER_DETAILS: "API_USER_DETAILS",
  SET_USER_DETAILS: "SET_USER_DETAILS",
  GET_UPCOMING_INVOICE: "GET_UPCOMING_INVOICE",
  SET_UPCOMING_INVOICE: "SET_UPCOMING_INVOICE",
  GET_INVOICE_HISTORY: "GET_INVOICE_HISTORY",
  SET_INVOICE_HISTORY: "SET_INVOICE_HISTORY",
  GET_STRIPE_INVOICE: "GET_STRIPE_INVOICE",
  SET_STRIPE_INVOICE: "SET_STRIPE_INVOICE",
  GET_STRIPE_UPCOMING_INVOICE: "GET_STRIPE_UPCOMING_INVOICE",
  SET_STRIPE_UPCOMING_INVOICE: "SET_STRIPE_UPCOMING_INVOICE",
  GET_TIMELINEGRAPH_DETAILS: "GET_TIMELINEGRAPH_DETAILS",
  SET_BUY_PLAN_DETAILS: "SET_BUY_PLAN_DETAILS",
  API_CHECK_USER_HAS_PLAN: "API_CHECK_USER_HAS_PLAN",
  SET_CHECK_USER_HAS_PLAN: "SET_CHECK_USER_HAS_PLAN",
  API_IS_USER_PART_OF_ORG: "API_IS_USER_PART_OF_ORG",
  SET_IS_USER_PART_OF_ORG: "SET_IS_USER_PART_OF_ORG",
  // SET_TIMELINEGRAPH_DETAILS: "SET_TIMELINEGRAPH_DETAILS",
  GET_USER_CARDS: "GET_USER_CARDS",
  SET_USER_CARDS: "SET_USER_CARDS",
  GET_CASHFREE_CREATE_SUBSCRIPTION: "GET_CASHFREE_CREATE_SUBSCRIPTION",
  SET_CASHFREE_CREATE_SUBSCRIPTION: "SET_CASHFREE_CREATE_SUBSCRIPTION",
  GET_CASHFREE_UPDATE_SUBSCRIPTION: "GET_CASHFREE_UPDATE_SUBSCRIPTION",
  GET_STRIPE_CREATE_SUBSCRIPTION: "GET_STRIPE_CREATE_SUBSCRIPTION",
  GET_STRIPE_UPDATE_SUBSCRIPTION: "GET_STRIPE_UPDATE_SUBSCRIPTION",
  GET_STRIPE_UPDATE_ADDONS: "GET_STRIPE_UPDATE_ADDONS",
  API_GET_STRIPE_PUBLISHABLE_KEY: "API_GET_STRIPE_PUBLISHABLE_KEY",
  GET_CASHFREE_DISCOUNT: "GET_CASHFREE_DISCOUNT",
  SET_CASHFREE_DISCOUNT: "SET_CASHFREE_DISCOUNT",
  API_CREATE_ADDON_SUBSCRIPTION: "API_CREATE_ADDON_SUBSCRIPTION",
  API_FETCH_STATUS: "API_FETCH_STATUS",
  SET_FETCH_STATUS: "SET_FETCH_STATUS",
  FETCH_ALL_ORGS: "FETCH_ALL_ORGS",
  API_IS_VALID_ORG: "API_IS_VALID_ORG",
  API_ORG_USER_INVITATIONS: "API_ORG_USER_INVITATIONS",
  SET_ORG_USER_INVITATIONS: "SET_ORG_USER_INVITATIONS",
  API_UPDATE_ORG_USER_INVITATION: "API_UPDATE_ORG_USER_INVITATION",
  API_PERSONAL_DASHBOARD_STATS: "API_PERSONAL_DASHBOARD_STATS",
  API_GET_SEPCIFIC_PLAN: "API_GET_SEPCIFIC_PLAN",
  SET_GET_SEPCIFIC_PLAN: "SET_GET_SEPCIFIC_PLAN",
  API_FETCH_CHILD_ORGS: "API_FETCH_CHILD_ORGS",
  SET_FETCH_CHILD_ORGS: "SET_FETCH_CHILD_ORGS",
  API_FETCH_CHILD_ORG_DETAILS: "API_FETCH_CHILD_ORG_DETAILS",
  SET_FETCH_CHILD_ORG_DETAILS: "SET_FETCH_CHILD_ORG_DETAILS",
  API_GET_ALL_LICENSE: "API_GET_ALL_LICENSE",
  SET_ALL_LICENSE: "SET_ALL_LICENSE",
  // SITES-API'S
  API_ALL_SITES: "API_ALL_SITES",
  SET_ALL_SITES: "SET_ALL_SITES",
  API_GET_SELECTED_SITE_DETAILS: "API_GET_SELECTED_SITE_DETAILS",
  SET_SELECTED_SITE_DETAILS: "SET_SELECTED_SITE_DETAILS",
  API_DELETE_SITE: "API_DELETE_SITE",
  API_IS_VALID_SITE: "API_IS_VALID_SITE",
  API_SITES_LB_ARN: "API_SITES_LB_ARN",
  SET_SITES_LB_ARN: "SET_SITES_LB_ARN",
  API_GRAPH_DETAILS: "API_GRAPH_DETAILS",
  SET_GRAPH_DETAILS: "SET_GRAPH_DETAILS",
  API_SUBMIT_MIGRATE_DETAILS: "API_SUBMIT_MIGRATE_DETAILS",
  API_GET_MIGRATION_PROGRESS: "API_GET_MIGRATION_PROGRESS",
  SET_MIGRATION_PROGRESS: "SET_MIGRATION_PROGRESS",
  API_AUTO_LOGIN: "API_AUTO_LOGIN",
  // RESTORE AND BACKUPS
  API_GET_BACKUPS_DETAILS: "API_GET_BACKUPS_DETAILS",
  SET_BACKUP_DETAILS: "SET_BACKUP_DETAILS",
  API_GET_SITES_RESTORES: "API_GET_SITES_RESTORES",
  SET_SITES_RESTORES: "SET_SITES_RESTORES",
  API_CREATE_ON_DEMAND: "API_CREATE_ON_DEMAND",
  API_SITE_RESTORE_BACKUP: "API_SITE_RESTORE_BACKUP",
  API_SITE_DOWNLOAD_BACKUP: "API_SITE_DOWNLOAD_BACKUP",
  API_RESTORE_DEDICATED_SITE: "API_RESTORE_DEDICATED_SITE",
  API_DEDICATED_ON_DEMAND_BACKUP: "API_DEDICATED_ON_DEMAND_BACKUP",
  // EBS (v2) sites: backups are EBS snapshots
  API_GET_EBS_BACKUPS_DETAILS: "API_GET_EBS_BACKUPS_DETAILS",
  SET_EBS_BACKUP_DETAILS: "SET_EBS_BACKUP_DETAILS",
  API_EBS_RESTORE_BACKUP: "API_EBS_RESTORE_BACKUP",
  API_EBS_CREATE_BACKUP: "API_EBS_CREATE_BACKUP",
  // STAGING DOMAINS
  API_CREATE_DOMAIN: "API_CREATE_DOMAIN",
  API_DELETE_DOMAIN: "API_DELETE_DOMAIN",
  // EBS (v2) sites: custom domains with AWS-issued SSL (ACM + CloudFront)
  API_EBS_SITE_DOMAINS: "API_EBS_SITE_DOMAINS",
  API_CHECK_DNS_STATUS: "API_CHECK_DNS_STATUS",
  // DEV TOOLS
  API_WP_DEBUG: "API_WP_DEBUG",
  API_WP_CACHE: "API_WP_CACHE",
  API_WAF: "API_WAF",
  SET_WAF: "SET_WAF",
  API_CREATE_SFTP_USER: "API_CREATE_SFTP_USER",
  API_DELETE_SFTP_USER: "API_DELETE_SFTP_USER",
  API_SFTP_USER_LIST: "API_SFTP_USER_LIST",
  SET_LIST_SFTP_USER: "SET_LIST_SFTP_USER",
  // EBS (v2) sites: one SFTP login per site (same password as SSH, chosen at creation)
  API_EBS_SFTP_DETAILS: "API_EBS_SFTP_DETAILS",
  SET_EBS_SFTP_DETAILS: "SET_EBS_SFTP_DETAILS",
  API_GET_TAG_NAME: "API_GET_TAG_NAME",
  API_GET_LABEL: "API_GET_LABEL",
  API_EXECUTE_COMMAND: "API_EXECUTE_COMMAND",
  // FILE EXPLORER
  API_GET_SITE_FILES: "API_GET_SITE_FILES",
  SET_SITE_FILES: "SET_SITE_FILES",
  SET_FILE_EXPLORER_LOCATION: "SET_FILE_EXPLORER_LOCATION",
  API_DELETE_SITE_FILE: "API_DELETE_SITE_FILE",
  API_DOWNLOAD_SITE_FILE: "API_DOWNLOAD_SITE_FILE",
  API_DOWNLOAD_SITE_FOLDER: "API_DOWNLOAD_SITE_FOLDER",
  API_INITIATE_MULTIPART_UPLOAD: "API_INITIATE_MULTIPART_UPLOAD",
  API_GET_MULTIPART_PRESIGNEDURLS: "API_GET_MULTIPART_PRESIGNEDURLS",
  API_FINALIZE_MULTIPART_UPLOAD: "API_FINALIZE_MULTIPART_UPLOAD",
  API_UPLOAD_SMALL_FILE: "API_UPLOAD_SMALL_FILE",
  API_UPLOAD_FILE: "API_UPLOAD_FILE",
  SET_FILE_UPLOAD_DETAILS: "SET_FILE_UPLOAD_DETAILS",
  SET_UPLOAD_PROGRESS: "SET_UPLOAD_PROGRESS",
  RESET_UPLOAD_PROGRESS: "RESET_UPLOAD_PROGRESS",
  // ALERTS
  API_GET_ALERTS: "API_GET_ALERTS",
  SET_ALERTS_DETAILS: "SET_ALERTS_DETAILS",
  // ORGANIZATION
  SELECT_ORG: "SELECT_ORG",
  SET_USER_ORGS_AND_SELECTED_ORG: "SET_USER_ORGS_AND_SELECTED_ORG",
  API_GET_SELECTED_ORG_FULL_INFO: "GET_UPDATED_ORG_INFO",
  CHANGE_ORG_NAME: "CHANGE_ORG_NAME",
  CHANGE_ORG_OWNER: "CHANGE_ORG_OWNER",
  CHANGE_OWNER: "CHANGE_OWNER",
  DELETE_ORG: "DELETE_ORG",
  UPDATE_MEMBER_ROLE: "UPDATE_MEMBER_ROLE",
  DELETE_MEMBER_FROM_ORG: "DELETE_MEMBER_FROM_ORG",
  API_GET_ORG_ACTIVITIES: "API_GET_ORG_ACTIVITY",
  SET_SELECTED_ORG_ACTIVITY: "SET_SELECTED_ORG_ACTIVITY",
  API_PERSONAL_USER_ACTIVITIES: "API_PERSONAL_USER_ACTIVITIES",
  PERSONAL_USER_ACTIVITIES: "PERSONAL_USER_ACTIVITIES",
  API_GET_TIMELINEGRAPH_DETAILS: "API_GET_TIMELINEGRAPH_DETAILS",
  SET_TIMELINEGRAPH_DETAILS: "SET_TIMELINEGRAPH_DETAILS",
  API_SELECTED_ORG: "API_SELECTED_ORG",
  SET_SELECTED_ORG: "SET_SELECTED_ORG",
  API_INVITE_USERS: "API_INVITE_USERS",
  API_BULK_INVITE_USERS: "API_BULK_INVITE_USERS",
  API_ORGANIZATION_IMAGE: "API_ORGANIZATION_IMAGE",
  SET_ORGANIZATION_IMAGE: "SET_ORGANIZATION_IMAGE",
  API_DELETE_ORG_IMAGE: "API_DELETE_ORG_IMAGE",
  API_GET_OTP: "API_GET_OTP",
  API_VERIFY_OTP: "API_VERIFY_OTP",
  API_SET_CHILD_ORG_COUNTRY: "API_SET_CHILD_ORG_COUNTRY",
  API_GET_CHILD_PLAN_DETAILS: "API_GET_CHILD_PLAN_DETAILS",
  SET_CHILD_PLAN_DETAILS: "SET_CHILD_PLAN_DETAILS",
  API_GET_ORG_ADDRESS: "API_GET_ORG_ADDRESS",
  SET_ORG_ADDRESS: "SET_ORG_ADDRESS",
  // BLUEPRINTS
  API_CREATE_BLUEPRINT: "API_CREATE_BLUEPRINT",
  API_DELETE_BLUEPRINT: "API_DELETE_BLUEPRINT",
  API_RENAME_BLUEPRINT: "API_RENAME_BLUEPRINT",
  API_GET_ALL_BLUEPRINT: "API_GET_ALL_BLUEPRINT",
  SET_GET_ALL_BLUEPRINT: " SET_GET_ALL_BLUEPRINT",
  API_GET_ALL_SPECIFIC_BLUEPRINT: "API_GET_ALL_SPECIFIC_BLUEPRINT",
  SET_GET_ALL_SPECIFIC_BLUEPRINT: "SET_GET_ALL_SPECIFIC_BLUEPRINT",
  API_IS_VALID_BLUEPRINT_NAME: "API_IS_VALID_BLUEPRINT_NAME",
  API_IMAGE_UPLOAD_BLUEPRINT: "API_IMAGE_UPLOAD_BLUEPRINT",
  API_REMOVE_BLUEPRINT_IMAGE: "API_REMOVE_BLUEPRINT_IMAGE",
  // CREATESITE
  API_CREATE_SITE_SELECTED_ORG: "API_CREATE_SITE_SELECTED_ORG",
  SET_CREATE_SITE_SELECTED_ORG: "SET_CREATE_SITE_SELECTED_ORG",
  API_CREATE_SITE: "API_CREATE_SITE",
  API_CREATE_NEW_STAGING_DOMAIN: "API_CREATE_NEW_STAGING_DOMAIN",
  // Sites
  API_SITES: "API_SITES",
  SET_SITES: "SET_SITES",
  API_S3_SIGNED_URL: "API_S3_SIGNED_URL",
  SET_S3_SIGNED_URL: "SET_S3_SIGNED_URL",
  API_SITE_IMAGE: "API_SITE_IMAGE",
  SET_SITE_IMAGE: "SET_SITE_IMAGE",
  API_REMOVE_SITE_IMAGE: "API_REMOVE_SITE_IMAGE",
  API_CACHE_INVALIDATION: "API_CACHE_INVALIDATION",
  API_TOP_SITES: "API_TOP_SITES",
  SET_TOP_SITES: "SET_TOP_SITES",
  API_SITES_LIST: "API_SITES_LIST",
  SET_SITES_LIST: "SET_SITES_LIST",
  API_CREATE_STAGING: "API_CREATE_STAGGING",
  API_DELETE_STAGING: "API_DELETE_STAGGING",
  API_PAY_STAGING_STRIPE: "API_PAY_STAGING_STRIPE",
  API_PAY_STAGING_CASHFREE: "API_PAY_STAGING_CASHFREE",
  API_PAY_STORAGE_STRIPE: "API_PAY_STORAGE_STRIPE",
  API_PAY_STORAGE_CASHFREE: "API_PAY_STORAGE_CASHFREE",
  API_PAY_PERFORMANCE_UPGRADE_STRIPE: "API_PAY_PERFORMANCE_UPGRADE_STRIPE",
  API_PAY_PERFORMANCE_UPGRADE_CASHFREE: "API_PAY_PERFORMANCE_UPGRADE_CASHFREE",
  API_TOGGLE_STAGING: "API_TOGGLE_STAGING",
  SET_TOGGLE_STAGING: "SET_TOGGLE_STAGING",
  SET_SELECTED_DOMAIN: "SET_SELECTED_DOMAIN",
  API_STAGING_DOMAIN_LIST: "API_STAGING_DOMAIN_LIST",
  SET_STAGING_DOMAIN_LIST: "SET_STAGING_DOMAIN_LIST",
  API_STAGING_TIMESTAMP: "API_STAGING_TIMESTAMP",
  SET_STAGING_TIMESTAMP: "SET_STAGING_TIMESTAMP",
  API_SSL_HANDLER: "API_SSL_HANDLER",
  API_DOWNLOAD_INSTANCE_KEY: "API_DOWNLOAD_INSTANCE_KEY",
  API_GET_INSTANCE_PASSWORD: "API_GET_INSTANCE_PASSWORD",
  SET_INSTANCE_PASSWORD: "SET_INSTANCE_PASSWORD",
  API_INSTALL_INSTANCE_DOMAIN: "API_INSTALL_INSTANCE_DOMAIN",
  API_DEDICATED_STORAGE: "API_DEDICATED_STORAGE",
  SET_DEDICATED_STORAGE: "SET_DEDICATED_STORAGE",
  API_GET_PHP_CREDS: "API_GET_PHP_CREDS",
  SET_DEDICATED_PHP_CREDS: "SET_PHP_CREDS",
  // NOTIFICATIONS
  API_GET_USER_NOTIFICATIONS: "API_GET_USER_NOTIFICATIONS",
  SET_USERS_NOTIFICATIONS: "SET_USERS_NOTIFICATIONS",
  API_MARK_NOTIFICATIONS_READ: "API_MARK_NOTIFICATIONS_READ",
  // Profile
  API_UPDATE_USER_DETAILS: "API_UPDATE_USER_DETAILS",
  API_SITES_DOMAIN_SSL_STATUS: "API_SITES_DOMAIN_SSL_STATUS",
  SET_DOMAIN_SSL_STATUS: "SET_DOMAIN_SSL_STATUS",
  API_USERS: "API_USERS",
  API_MAKE_TEMP_DOMAIN_LIVE: "API_MAKE_TEMP_DOMAIN_LIVE",
  //Support
  API_SEND_INVITE_TO_HELP_CENTER: "API_SEND_INVITE_TO_HELP_CENTER",
  API_DOMAIN_SSL_STATUS: "API_DOMAIN_SSL_STATUS",
  API_SEND_FEEDBACK: "API_SEND_FEEDBACK",
  API_WP_VERSION_UPDATE: "API_WP_VERSION_UPDATE",
  SET_ORG_DETAILS: "SET_ORG_DETAILS",
  SET_SITE_DETAILS: "SET_SITE_DETAILS",
  SET_BILL_DETAILS: "SET_BILL_DETAILS",
  API_SITE_OVERVIEW: "API_SITE_OVERVIEW",
  SET_SITE_OVERVIEW: "SET_SITE_OVERVIEW",
  SET_PLAN: "SET_PLAN",
  API_FETCH_PLAN_OVERGAUGE: "API_FETCH_PLAN_OVERGAUGE",
  SET_PLAN_OVERGAUGE: "SET_PLAN_OVERGAUGE",
  // Theme
  API_GET_THEME_DETAILS: "API_GET_THEME_DETAILS",
};
